import { io } from 'socket.io-client';
import { HTTP_PORT } from './constants';

export const createSocketConnection = function () {
  return io(`http://localhost:${HTTP_PORT}`);
};
